import request from 'checkout/utils/axios'

const getSummary = async () => {
  const response = await request
    .get('/api/v1/cart/summary')
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export default getSummary
